import { ReactElement, useState } from 'react'
import {
  PageWrapper,
  SectionTitle,
  SubHeader,
  CardWrapper,
  Button
} from '../../../../../components'
import strings from '../../../../../locale/en'
import { useHistory } from 'react-router-dom'
import { H3, Body, Span } from '../../../../../typography'
import { FlexWrapper } from './subcomponents'
import SecondaryButton from 'react-bootstrap/Button'

const Questions = (): ReactElement => {
  const [questionIndex, setQuestionIndex] = useState(0)
  const {
    menu: {
      admin: {
        createTest: { evaluate, reportedBy, answer, reportedAnswer }
      }
    },
    button: { approve, reject }
  } = strings
  const history = useHistory()
  const questions = [
    {
      reportedBy: 'Deepan'
    },
    {
      reportedBy: 'Dina'
    }
  ]

  const handleNext = () => {
    if (questionIndex === questions.length - 1) {
      return history.goBack()
    }
    setQuestionIndex(questionIndex + 1)
  }

  const handleApprove = () => {
    handleNext()
  }

  const handleReject = () => {
    handleNext()
  }

  return (
    <PageWrapper id="container">
      <SectionTitle title={evaluate} />
      <SubHeader
        title={'Test name'}
        handleBack={() => {
          history.goBack()
        }}
      />
      <CardWrapper>
        <FlexWrapper hasBorder>
          <H3 hasPadding>
            {reportedBy}
            <Span>{questions[questionIndex].reportedBy}</Span>
          </H3>
        </FlexWrapper>
        <FlexWrapper hasBorder>
          <div>
            <Body>Question 1:</Body>
            <Body>Question details</Body>
          </div>
        </FlexWrapper>
        <FlexWrapper hasBorder>
          <div>
            <H3 hasPadding>
              {answer}
              <Span>D</Span>
            </H3>
            <H3 hasPadding>
              {reportedAnswer}
              <Span>A</Span>
            </H3>
          </div>
        </FlexWrapper>
        <FlexWrapper justifyContent="center">
          <SecondaryButton variant="outline-secondary" onClick={handleReject}>
            {reject}
          </SecondaryButton>
          <Button onClick={handleApprove}>{approve}</Button>
        </FlexWrapper>
      </CardWrapper>
    </PageWrapper>
  )
}

export default Questions
